/**
 * @summary Available events
 * @enum {string}
 * @memberof PSV.plugins.ResolutionPlugin
 * @constant
 */
export const EVENTS = {
  /**
   * @event resolution-changed
   * @memberof PSV.plugins.ResolutionPlugin
   * @summary Triggered when the resolution is changed
   * @param {string} resolutionId
   */
  RESOLUTION_CHANGED: 'resolution-changed',
};
